import { createTheme } from "@mui/material/styles";
import { ACCENT, SHADOW, SITE_BG, SURFACE, TEXT, THEME_MODE } from "./palette";

/**
 * MUI theme for the user-facing site, built from the tokens in `palette.js`.
 *
 * This is what makes a season change cheap: every `Card`, `Paper`, `Dialog`,
 * `Chip`, `Divider` and `text.secondary` on a user page reads its colour from
 * here, so most pages need no edits of their own. Only hand-rolled colours
 * (see `surfaces.js`) have to be touched per page.
 */
export const userTheme = createTheme({
    palette: {
        mode: THEME_MODE,
        primary: {
            main: ACCENT.main,
            dark: ACCENT.dark,
            light: ACCENT.light,
            contrastText: ACCENT.contrastText,
        },
        background: {
            default: SITE_BG,
            paper: SURFACE.card,
        },
        text: {
            primary: TEXT.primary,
            secondary: TEXT.secondary,
            disabled: TEXT.disabled,
        },
        divider: SURFACE.border,
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                // Dark-mode elevation overlays wash the slate out; keep the flat token.
                root: { backgroundImage: "none" },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: SURFACE.card,
                    boxShadow: SHADOW.card,
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: { backgroundColor: "#1f2b47", color: TEXT.primary },
                arrow: { color: "#1f2b47" },
            },
        },
    },
});

export default userTheme;
